import React, { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { TextButton, TextButtonClassNames } from '../../../commons/buttons/TextButton';
import { CustomMUIButton } from '../../../commons/buttons/CustomMUIButton';
import { ReactComponent as EditPencilIcon } from '../../../../assets/images/EditPencil.svg';
import { ButtonClassNames } from '../../../../models/Common';
import { ReactComponent as DeleteIcon } from '../../../../assets/images/Delete.svg';
import { phoneNumberWithSpaces } from '../../../../utils';

interface MainePhoneProps {
  value: string | number | null;
  handleAddPhone: (modalTitle: string, description?: string) => void;
  handleDeletePhone: (phone: string) => void;
  handleEditSmsPhone: (modalTitle: string, description?: string) => void;
}

export const MainePhone: FC<MainePhoneProps> = ({ value, handleAddPhone, handleDeletePhone, handleEditSmsPhone }) => {
  const { t } = useTranslation();

  return value ? (
    <>
      {phoneNumberWithSpaces(value.toString())}
      <div className="account__info__item__description_absolute account__info__item__description_absolute__button ">
        <CustomMUIButton
          label={<EditPencilIcon />}
          handleClick={() => handleEditSmsPhone(t('accountSettings.changingPrimaryPhoneNumber'))}
          className={ButtonClassNames.IconFulfilled}
        />
      </div>
      <div className="account__info__item__description_absolute account__info__item__description_absolute__button account__info__item__description_absolute__button__delete">
        <CustomMUIButton
          label={<DeleteIcon />}
          handleClick={() => handleDeletePhone(`${value}`)}
          className={ButtonClassNames.IconFulfilled}
          tooltipText={`${t('buttons.delete')}`}
        />
      </div>
    </>
  ) : (
    <TextButton
      label={`${t('buttons.addPhoneNumber')} +`}
      handleClick={() => handleAddPhone(t('accountSettings.addingPrimaryPhoneNumber'))}
      className={TextButtonClassNames.PrimaryActive}
    />
  );
};
